<script lang="ts">
    import { onMount } from 'svelte';
    import Newsletter from '../components/Newsletter.svelte';
    import ActuInsight from '../components/ActuInsight.svelte';
    import BallsActus from '../components/BallsActus.svelte';
    import { storeProjets, Actu } from '../scripts/classes/actu';
    import NewsletterRegistration from '../components/NewsletterRegistration.svelte';

    let projets: Actu[] = $storeProjets;
    let numberOfProjetsDisplayed: number = 10;
    let numberOfProjetsTotal: number = $storeProjets.length;

    onMount(async () => {
        window.scrollTo(0,0);
	});

    function moreProjets() {
        numberOfProjetsDisplayed = numberOfProjetsDisplayed + 10;
    }

</script>
    
<style lang="scss">

    .projets {
        &__filters {
            font-family: 'Borna-Medium';
            font-size: 13px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin: 60px 0 0 0;
            width: 110%;
            height: 27.5px;
            &__button {
                width: auto;
                height: 100%;
                background-color: $color_white;
                border: 1px solid $color_black;
                border-left: 0px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 0 10px 0 10px;
                box-sizing: border-box;
                &__selected {
                    background-color: $color_primary;
                }
                &__first {
                    border-left: 1px solid $color_black;
                    border-radius: 30px 0 0 30px;
                }
                &__last {
                    border-radius: 0px 30px 30px 0;
                }
            }
        }
        &__search {
            width: 90%;
            border: 1px solid $color_black;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-top: 5px;
            box-sizing: border-box;
            &__input__mobile {
                all: unset;
                width: 100%;
                border: none;
                font-family: 'Borna-Medium';
                font-size: 14px;
                padding: 20px 20px 20px 20px;
            }
            &__input {
                display: none;
            }
            &__btn {
                cursor: pointer;
                margin: 0 15px 0 0;
                width: 50px;
                height: 50px;
                background-image: url('../assets/images/btn_search.svg');
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                &__close {
                    background-image: url('../assets/images/btn_close.svg');
                }
            }
        }
        &__lesprojets {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            margin: 0 0 50px 0px;
        }
        &__actuinsight {
            margin: 36px 15px 0 15px;
        }
        &__more {
            margin-bottom: -25px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-family: 'Borna-Medium';
            font-size: 14px;
            &__btn {
                cursor: pointer;
                margin: 15px 0 0 0;
                width: 50px;
                height: 50px;
                background-image: url('../assets/images/btn_charger_plus.svg');
            }
        }
    }

    @include large {
        .projets {
            &__filters {
                width: auto;
                font-size: 1.2vw;
                height: 60px;
                position: absolute;
                margin: -30px 0 0 0;
                align-self: flex-end;
                justify-content: center;
                &__button {
                    width: auto;
                    cursor: pointer;
                    margin: 0 20px 0 0;
                    padding: 0 30px 0 30px;
                    border-radius: 30px;
                    border-left: 1px solid $color_black;
                    &:hover {
                        background-color: $color_primary;
                    }
                    &__first {
                        border-left: 1px solid $color_black;
                    }
                }
            }
            &__search {
                width: 100%;
                &__input__mobile {
                    display: none;
                }
                &__input {
                    all: unset;
                    width: 100%;
                    border: none;
                    font-family: 'Borna-Medium';
                    font-size: 1.1vw;
                    padding: 20px 20px 20px 20px;
                }
                &__btn {
                    &:hover {
                        background-image: url('../assets/images/btn_search_hover.svg');
                    }
                    &__close {
                        &:hover {
                            background-image: url('../assets/images/btn_close_hover.svg');
                        }
                    }
                }
            }
            &__lesprojets {
                flex-direction: row;
                margin: 0 0 70px 0px;
            }
            &__actuinsight {
                margin: 50px 15px 0 15px;
            }
            &__more {
                &__btn {
                    &:hover {
                        background-image: url('../assets/images/btn_charger_plus_hover.svg');
                    }
                }
            }
        }

    }

    @include xlarge {
        .projets {
            &__filters {
                font-size: 22px;
            }
            &__search {
                &__input {
                    font-size: 20px;
                }
            }
        }
    }

</style>

<div class="page">
    <div class="page__contener">
        <div class="page__title">découverte des projets PTCE</div>
        <div class="page__content">
            <div class="projets__lesprojets">
                {#key numberOfProjetsDisplayed}
                {#each projets as actu, i}
                {#if (i < numberOfProjetsDisplayed)}
                <div class="projets__actuinsight">
                    {#key actu}
                    <ActuInsight inActu={actu}/>
                    {/key}
                </div>
                {/if}
                {/each}
                {/key}
            </div>
            {#if numberOfProjetsDisplayed < numberOfProjetsTotal}
            <div class="projets__more">
                <div>charger</div>
                <div>plus de projets</div>
                <div class="projets__more__btn" on:click={moreProjets} on:keydown={moreProjets}></div>
            </div>
            {/if}
        </div>
    </div>
    <BallsActus />
    <Newsletter />
    <NewsletterRegistration />
</div>
